import { Layout, Spin } from 'antd';
import { useAuthConnectionEffect } from 'hooks/useAuthConnectionEffect';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { initConnectionAsync, selectConnection } from 'slices/connection';
import * as MyAccountSlice from 'slices/myAccount';
import useErrorBoundary from 'use-error-boundary';
import AccountListPage from 'views/accounts';
import AccountDetailsPage from 'views/accounts/details';
import AuditsPage from 'views/audit';
import DotPage from 'views/dot';
import ManualPatchesPage from 'views/manual-patch';
import ManualPatchDetails from 'views/manual-patch/details';
import SubscriptionLockPage from 'views/subscriptionLocks';
import Header from '../components/Header';
import { useSessionStorage } from '../hooks/use-session-storage';
import AlertsPage from './alert';
import './App.css';
import HelpPage from './help';
import BackgroundJobsPage from './jobs';
import Login from './login';
import { ViolationsPage } from './violations';

const App = () => {
  const { ErrorBoundary, didCatch, error } = useErrorBoundary();
  const { authenticated, loading } = useSelector(selectConnection);
  const [
    ,
    ,
    removeEngineHoursValidationState,
  ] = useSessionStorage('enable-engine-hours-validation', true);
  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initConnectionAsync());
  }, []);
  useAuthConnectionEffect(() => {
    dispatch(MyAccountSlice.subscribe({}));
    return () => {
      dispatch(MyAccountSlice.unsubscribe({}));
    };
  });

  useEffect(() => {
    if (!loading && !authenticated) {
      removeEngineHoursValidationState();
    }
  }, [
    loading,
    authenticated,
  ]);

  return (
    <>
      {didCatch ? (
        <Layout>
          <Header />
          <Layout.Content
            style={{
              height: 'calc(100vh - 64px)',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <strong style={{ flexGrow: 1, textAlign: 'center' }}>An error has been caught: {error.message}</strong>
          </Layout.Content>
        </Layout>
      ) : (
        <ErrorBoundary>
          <Switch location={location}>
            <Route path="/login" exact>
              <Login />
            </Route>
            {authenticated || loading ? (
              <>
                <Spin spinning={loading}>
                  <Layout>
                    <Header />
                    <Switch>
                      <Route path="/accounts/:accountId" children={<AccountDetailsPage />} />
                      <Route path="/accounts" children={<AccountListPage />} />
                      <Route path="/activity" children={<ManualPatchesPage />} exact />
                      <Route path="/activity/:manualPatchId" exact children={<ManualPatchDetails />} />
                      <Route path="/violations" children={<ViolationsPage />} />
                      <Route path="/audits" children={<AuditsPage />} />
                      <Route path="/alerts" children={<AlertsPage />} />
                      <Route path="/dot" children={<DotPage />} />
                      <Route path="/subscription-lock" children={<SubscriptionLockPage />} />
                      <Route path="/jobs" children={<BackgroundJobsPage />} />
                      <Route path="/help-and-support" children={<HelpPage />} />
                      <Redirect
                        path="/"
                        exact
                        to={{
                          pathname: '/activity',
                        }}
                      />
                    </Switch>
                  </Layout>
                </Spin>
              </>
            ) : (
              !loading && (
                <Redirect
                  to={{
                    pathname: '/login',
                  }}
                />
              )
            )}
          </Switch>
        </ErrorBoundary>
      )}
    </>
  );
};

export default App;
